module.exports = __webpack_public_path__ + "components/rewards-header/static/unlock-black-3b45227c97b7fa2a8eb9c90086a22bda.svg";